import {
  SocialPostAttachment,
  SocialHashtag,
  Attachment,
  AttachmentType,
} from 'types/AmplifiedTemplate';

export const formatHashtags = (hashtags?: SocialHashtag[]) =>
  hashtags?.map((ht) => `#${ht.hashtag.name}`).join(' ') ?? '';

export const getNormalizedHashtags = (hashtags: string) =>
  hashtags
    .split(/\s+/)
    .filter(Boolean)
    .map((tag) => (tag.startsWith('#') ? tag : `#${tag}`));

/**
 * Loose input type: only the fields the utils actually read are required;
 * id/sort_order are not accessed so they are kept optional via Partial.
 */
type AttachmentObjInput =
  | (Partial<Omit<SocialPostAttachment, 'attachment'>> & {
      attachment?: Partial<Attachment> | null;
    })
  | null
  | undefined;

export const getAttachmentsPayload = (
  attachments: AttachmentObjInput[],
): (Partial<Attachment> & { type: AttachmentType })[] => {
  return attachments.flatMap((attachmentObj) => {
    if (!attachmentObj?.attachment) return [];
    const { type, url, thumbnail_url, title } = attachmentObj.attachment;
    if (!type) return [];
    return [
      {
        type,
        ...(url != null && { url }),
        ...(thumbnail_url != null && { thumbnail_url }),
        ...(title != null && { title }),
      },
    ];
  });
};

export const hasMediaPreview = (firstAttachment: AttachmentObjInput) => {
  const isVideo = firstAttachment?.attachment?.type === AttachmentType.Video;
  const isImage = firstAttachment?.attachment?.type === AttachmentType.Image;
  const attachmentSrc = firstAttachment?.attachment?.url || '';
  const thumbnailSrc = firstAttachment?.attachment?.thumbnail_url || '';

  return !!(
    thumbnailSrc ||
    (isVideo && attachmentSrc) ||
    (isImage && attachmentSrc)
  );
};
